import { render, staticRenderFns } from "./TranslateExamButton.vue?vue&type=template&id=18cb8f66&"
import script from "./TranslateExamButton.vue?vue&type=script&lang=js&"
export * from "./TranslateExamButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports